import * as axiosService from "./axiosService";



export const userExistsApi = (countryCode,mobile,email,userId,isForLogin) => {
    return axiosService.Get(process.env.REACT_APP_COMMON_API_URL + `/User/IsUserExists?countryCode=${countryCode}&mobileNo=${mobile}&emailId=${email ? email:""}&userId=${userId ? userId:""}&isForLogin=${isForLogin ? true:false}`);
};


// export const sendOTP = (payload) => {
//     return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/SendOtp`, payload);
// };
export const sendOTP = (payload) => {
    return axiosService.PostWithWebPlatform(process.env.REACT_APP_COMMON_API_URL + `/Account/SendOtp`, payload);
};


// export const resendOTP = (payload) => {
//     return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/ResendOtp`, payload);
// };

export const resendOTP = (payload) => {
    return axiosService.PostWithWebPlatform(process.env.REACT_APP_COMMON_API_URL + `/Account/ResendOtp`, payload);
};


export const verifyOTP = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/VerifyOtp`, payload);
};

// export const sendForgetOTP = (payload) => {
//     return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/ForgotPin/SendOtp`, payload);
// };
export const sendForgetOTP = (payload) => {
    return axiosService.PostWithWebPlatform(process.env.REACT_APP_COMMON_API_URL + `/Account/ForgotPin/SendOtp`, payload);
};

export const verifyForgetOTP = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/ForgotPin/VerifyOtp`, payload);
};

export const setForgetPin = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/ForgotPin/SetPin`, payload);
};
export const verifyOtpToChangeMobileNumber = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/VerifyOtpToChangeMobileNumber`, payload);
};
export const refreshToken = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/RefreshToken`, payload);
};
export const verifyOtpToChangeEmail = (payload) => {
    return axiosService.Post(process.env.REACT_APP_COMMON_API_URL + `/Account/VerifyOtpToChangeEmail`, payload);
};
